module.exports = "Regardless of how you feel about it, some things to note:\n\n- NOT writing HTML in JS\n\n- NOT an HTML template language\n\n- Expressions evaluate to function calls React.createElement()\n\n- Decide for yourself\n\n- Rest of the examples will use it"


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/notes_6.md
// module id = 1504
// module chunks = 0